module.exports = __webpack_public_path__ + "img/circle-7.3c30c7d.png";